var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-label',{attrs:{"label":_vm.status.label,"status":_vm.billingDocumentStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }